module.exports = __webpack_public_path__ + "static/media/drive.5c002ce8.png";